import React from 'react';

interface NotificationItemProps {
    label: string;
    description: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
    label,
    description,
    checked,
    disabled = false,
    onChange
}) => {
    return (
        <div className="notification-item">
            <div className="notification-info">
                <div className="notification-label">{label}</div>
                <div className="notification-description">{description}</div>
            </div>
            <label className="toggle-switch">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                />
                <span className="toggle-slider"></span>
            </label>
        </div>
    );
};
